import { Link as RouterLink } from "react-router-dom"

import {
    APPBAR_WITHOUT_MODULES_HEIGHT,
    styled,
    styledForMobile,
    Typography as UiTypography,
} from "@l2r-front/l2r-ui"

import { AppBar as AppBarComponent } from "../../components/AppBar"
import { NetworkSelector as L2rNetworkSelector } from "../../containers/NetworkSelector"

export const TextContainer = styledForMobile("div")(({ isMobile, theme }) => ({
    alignItems: "baseline",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(7),
    height: `calc(100% - ${APPBAR_WITHOUT_MODULES_HEIGHT}px)`,
    justifyContent: isMobile ? "flex-start" : "center",
    right: isMobile ? 0 : "20%",
    padding: isMobile ? theme.spacing(16, 4) : 0,
    position: isMobile ? "block" : "absolute",
}))

export const Typography = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["primary"].contrastText,
}))

export const ImageContainer = styled("div")(({ src }) => ({
    backgroundImage: `url(${src})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingTop: APPBAR_WITHOUT_MODULES_HEIGHT,
    height: "100%",
    width: "100%",
}))

export const PageContainer = styled("div")(({ theme }) => ({
    height: "100%",
    backgroundColor: theme.errorBackground,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
}))

export const AppBar = styled(AppBarComponent)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 2,
}))

export const Link = styled(RouterLink)({
    alignItems: "center",
    display: "flex",
    height: "100%",
})

export const NetworkSelector = styled(L2rNetworkSelector)({
    marginLeft: "auto",
})

export const Logo = styled("img")(() => ({
    height: 36,
}))

export const SmallLogo = styled("img")(() => ({
    height: 30,
}))

export const MenuWrapper = styled("div")(({ theme }) => ({
    alignItems: "flex-start",
    display: "flex",
    height: "fit-content",
    justifyContent: "flex-end",
    position: "fixed",
    left: theme.spacing(6),
    top: theme.spacing(8),
    zIndex: 3,
}))